/* eslint-disable no-case-declarations */
import {
  LOGINOUT_SUCCESS,
  // LOGIN_START,
  // LOGIN_MODAL_VISIBLE,
  LOGIN_SUCCESS,
  // LOGIN_ACCOUNT_OR_PASSWORD_ERROR,
  // LOGIN_TIMEOUT,
  // REGISTER,
  // GET_USER_INFO,
  GET_DEVELOPER_INFO_SUCCESS,
  GET_USER_INFO_SUCCESS
  // APPLY_FOR_VERIFY,
  // REGISTER_END
  // RESET_ERROR
} from '@console/store/actionTypes/homepage'

interface IUserInfo {
  userid: string
  apptoken: string | null
  nickName: string | null
  country: string | null
  avatar: string
  loginToken: string | null
  contact: string
  region: string
}

interface IDeveloperInfo {
  id: string
  email: string
  address: string
  phone: string
  name: string
  type: any
  status: number
  merchantStatus: number
}

interface IState {
  userInfo: IUserInfo
  developerInfo: IDeveloperInfo
  isDeveloperInfoLoaded: boolean
  isLogin: boolean
  // isLoginPending: boolean
  // isLoginModalVisible: boolean
  // isLoginAccountOrPasswordError: boolean
  // isLoginTimeout: boolean
}

const initialState: IState = {
  userInfo: {
    userid: '',
    apptoken: '',
    nickName: '',
    country: '',
    loginToken: '',
    avatar: '',
    contact: '',
    region: ''
  },
  developerInfo: {
    id: '',
    email: '',
    address: '',
    phone: '',
    name: '',
    type: '', // 开发者类型 0:企业 1:个人 2:其他
    status: 0, // 开发者认证状态 0:未入驻 1:入驻审核中 2:入驻成功 3:审核失败 4:停止认证
    merchantStatus: 0 // 商户认证状态：0-未认证，1-已认证
  },
  isDeveloperInfoLoaded: false,
  isLogin: false // 是否已登录
  // isLoginPending: false, // 登录按钮Pending状态
  // isLoginModalVisible: false, // 登录框是否可见
  // isLoginAccountOrPasswordError: false, // 是否账号或密码错误
  // isLoginTimeout: false // 是否登录超时
}

const reducer = (state = initialState, action: any) => {
  const { type, payload } = action
  switch (type) {
    // 登录成功
    case LOGIN_SUCCESS:
      return {
        ...state,
        isLogin: true
        // isLoginPending: false,
        // isLoginModalVisible: false,
        // isLoginAccountOrPasswordError: false,
        // isLoginTimeout: false
      }
    // 注册成功
    // case REGISTER_END:
    //   const { userid, apptoken, nickName: name, country, avatar, developerID, email } = payload
    //   return {
    //     ...state,
    //     userInfo: {
    //       ...state.userInfo,
    //       userid,
    //       apptoken,
    //       nickName: name,
    //       country,
    //       avatar
    //     },
    //     developerInfo: {
    //       ...state.developerInfo,
    //       id: developerID,
    //       email
    //     },
    //     isLogin: true
    //   }
    // 查询用户信息
    case GET_USER_INFO_SUCCESS:
      return {
        ...state,
        userInfo: {
          ...state.userInfo,
          userid: payload.userid || state.userInfo.userid,
          apptoken: payload.apptoken || state.userInfo.apptoken,
          loginToken: payload.loginToken || state.userInfo.loginToken,
          nickName: payload.nickName || state.userInfo.nickName,
          country: payload.country || state.userInfo.country,
          avatar: payload.avatar || state.userInfo.avatar,
          contact: payload.contact || state.userInfo.contact,
          region: payload.region || state.userInfo.region
        }
      }
    // 查询开发者认证信息
    case GET_DEVELOPER_INFO_SUCCESS: {
      const {
        contactMailbox,
        contactAddress,
        contactNumber,
        contactName,
        examineType,
        id,
        code,
        merchantStatus,
        developerTag,
        state: developerState
      } = payload
      if ((code && code < 0) || !id) {
        return {
          ...state,
          developerInfo: initialState.developerInfo,
          isDeveloperInfoLoaded: true
        }
      }
      return {
        ...state,
        isDeveloperInfoLoaded: true,
        developerInfo: {
          ...state.developerInfo,
          id,
          type: payload.state,
          status: examineType ?? 0,
          merchantStatus: merchantStatus ?? 0,
          email: contactMailbox,
          address: contactAddress,
          phone: contactNumber,
          name: contactName,
          developerTag,
          state: developerState
        }
      }
    }
    // 退出登录
    case LOGINOUT_SUCCESS:
      return {
        ...state,
        isLogin: false,
        userInfo: {
          userid: '',
          apptoken: '',
          nickName: '',
          country: '',
          loginToken: '',
          avatar: '',
          contact: ''
        },
        developerInfo: {
          id: '',
          email: '',
          address: '',
          phone: '',
          name: '',
          type: '',
          status: 0,
          merchantStatus: 0
        },
        isDeveloperInfoLoaded: false
      }
    default:
      return state
  }
}

export default reducer
